import React, { lazy } from "react";
import { Routes, Route } from "react-router-dom";
import MainLayout from "../layout/MainLayout";
import Notification from "../Screens/Notifications/Notification";
import AMCPayment from "../Screens/AMC/AMCPayment";
import WebsiteOffer from "../Screens/Offers/WebsiteOffer";

//Dynamic Imports
const Profile = lazy(() => import("../Screens/Profile/Profile"));
const Booking = lazy(() => import("../Screens/Bookings/Booking"));
const DashboardOfferBooking = lazy(() =>
  import("../Screens/Bookings/DashboardOfferBooking")
);
const ViewProduct = lazy(() => import("../Screens/Product/ViewProduct"));
const BookingSlot = lazy(() => import("../Screens/Bookings/BookingSlot"));
const Reschedule = lazy(() => import("../Screens/Bookings/Reschedule"));
const RecommandService = lazy(() =>
  import("../Screens/Services/RecommandService")
);
const Dashboard = lazy(() => import("../Screens/Dashboard"));
const CartTab = lazy(() => import("../Screens/Cart/CartTab"));
const Payment = lazy(() => import("../Screens/Payments/Payment"));
const ProductPayment = lazy(() => import("../Screens/Product/ProductPayment"));
const PaymentSuccess = lazy(() => import("../Screens/Payments/PaymentSuccess"));
const ProductSuccess = lazy(() => import("../Screens/Product/ProductSuccess"));
const SubProducts = lazy(() => import("../Screens/Dashboard/SubProducts"));
const AMCDetail = lazy(() => import("../Screens/AMC/AMCDetail"));
const AMCPurchase = lazy(() => import("../Screens/AMC/AMCPurchase"));

const CategoryService = lazy(() =>
  import("../Screens/Dashboard/CategoryService")
);

const Offers = lazy(() => import("../Screens/Offers/Offers"));
const SpecialProducts = lazy(() =>
  import("../Screens/Product/SpecialProducts")
);
const SpecialAMC = lazy(() => import("../Screens/AMC/SpecialAMC"));
const OfferAMC = lazy(() => import("../Screens/AMC/ViewOfferAMC"));

const ViewOfferService = lazy(() =>
  import("../Screens/Offers/ViewOfferService")
);
const ViewOfferProducts = lazy(() =>
  import("../Screens/Offers/ViewOfferProducts")
);

const AppRoute = () => {
  return (
    <Routes>
      <Route element={<MainLayout />}>
        <Route index element={<Dashboard />} />
        <Route path="/dashboard" element={<Dashboard />} />
        <Route path="/Profile" element={<Profile />} />
        <Route path="/serviceSubcategory" element={<CategoryService />} />
        <Route path="/productSubcategory" element={<SubProducts />} />
        <Route path="/reschedule" element={<Reschedule />} />
        <Route path="/Booking" element={<Booking />} />
        <Route path="/offerBooking" element={<DashboardOfferBooking />} />
        <Route path="/Booking/Slot" element={<BookingSlot />} />
        <Route path="/Booking/Slot/payment" element={<Payment />} />
        <Route path="/productpayment" element={<ProductPayment />} />
        <Route path="/productSuccess" element={<ProductSuccess />} />
        <Route path="/ViewProduct" element={<ViewProduct />} />
        <Route
          path="/Booking/Slot/payment/success"
          element={<PaymentSuccess />}
        />
        <Route path="/cart" element={<CartTab />} />
        <Route path="/Notifications" element={<Notification />} />
        <Route path="/servicelist" element={<RecommandService />} />
        <Route path="/amcPlanDetail" element={<AMCDetail />} />
        <Route path="/amcPlanPayment" element={<AMCPayment />} />
        <Route path="/amcPurchaseSuccess" element={<AMCPurchase />} />

        <Route path="/offers" element={<Offers />} />

        {/* Product Offers */}
        <Route path="/view_offer_service" element={<ViewOfferService />} />
        <Route path="/view_special_products" element={<SpecialProducts />} />
        <Route path="/view_offer_product" element={<ViewOfferProducts />} />

        {/* AMC Offers */}
        <Route path="/view_special_amc" element={<SpecialAMC />} />
        <Route path="/view_offer_amc" element={<OfferAMC />} />

        {/* Website Offers */}
        <Route path="/offer_from_website" element={<WebsiteOffer />} />
      </Route>
    </Routes>
  );
};

// function wait(time) {
//   return new Promise((resolve) => {
//     setTimeout(resolve, time);
//   });
// }

export default AppRoute;
